'use client';

import { cn, TAlertModalProps } from 'types';
import { Button } from '../button';
import { CustomModal } from '../custom-modal';

export const AlertModal = ({
  open,
  className,
  title,
  titleGap = 'gap-2',
  actionsList,
  description,
  alertIcon,
  onCloseClick,
  overlayColor,
}: TAlertModalProps) => {
  return (
    <CustomModal
      open={open}
      className={cn('max-w-131.5 [&_.closing-button]:hidden', className)}
      onCloseClick={onCloseClick}
      autoCloseOnFocusOut
      overlayColor={overlayColor}
    >
      <div className="flex flex-col gap-8 p-8 pb-6">
        <div className="flex gap-2">
          {alertIcon && <div className="flex items-center justify-center max-w-8 max-h-8 shrink-0">{alertIcon}</div>}
          <div className={`flex flex-col ${titleGap}`}>
            <h2 className="text-xl/[180%] font-extrabold!">{title}</h2>
            {description && <div className="text-base/[175%] font-semibold">{description}</div>}
          </div>
        </div>
        {actionsList?.length > 0 && (
          <div className="flex justify-end gap-4">
            {actionsList.map((action, index) => (
              <Button
                key={index}
                variant={action.actionClassNames?.includes('tw-solid-red') && index === 0 ? 'red' : 'teal'}
                appearance={index === 0 ? 'solid' : 'outline'}
                className={cn('px-6 py-3', action.actionClassNames || '')}
                onClick={action.actionMethod}
                isLoading={action.actionLoading || false}
              >
                {action.actionLabel}
              </Button>
            ))}
          </div>
        )}
      </div>
    </CustomModal>
  );
};
